<!--
    TODO
    Fix the alignment here... check webpage rendering...
-->
<template>
    <div class="photos center" align-v="center">
        <b-modal 
            v-model="modalShow" 
            size="xl"
        >
            <b-container>
                <b-row>
                    <b-col>
                        <b-carousel
                            id="carousel-1"
                            v-model="slideNumber"
                            :interval="0"
                            controls
                            background="#ababab"
                            img-width="1024"
                            img-height="480"
                            style="text-shadow: 1px 1px 2px #333;"
                        >
                            <b-carousel-slide
                                v-for="photo in photos"
                                :key="photo.id"
                                :caption="photo.name"
                                :text="photo.name"
                                :img-src="photo.link"
                            ></b-carousel-slide>
                        </b-carousel>
                    </b-col>
                    <b-col cols="3">
                        <!--
                            TODO
                            Put photo comment
                        -->
                        <div v-if="photos.length != 0">
                            <b-row>
                            <div>
                                <b-img 
                                    rounded 
                                    :src="photos[slideNumber].user.profileImg" 
                                    alt="Image 1"
                                    height="40px"
                                    width="40px"
                                >
                                </b-img>
                            </div>
                            <div class="ml-4">
                                 <b-row>
                                    <b-link @click="goToPlace">
                                        {{photos[slideNumber].user.firstName}} {{photos[slideNumber].user.lastName}}
                                    </b-link>
                                </b-row>
                                <b-row>
                                    <b-icon icon="person" class="mr-1"></b-icon>{{photos[slideNumber].user.numberOfFriends}}
                                    <b-icon icon="asterisk" class="mr-1 ml-3"></b-icon>{{photos[slideNumber].user.numberOfRatings}}
                                </b-row>
                            </div>
                            </b-row>
                        </div>
                        <div class="text-muted my-2">
                            {{photos[slideNumber].created}}
                        </div>
                        <div style="display: inline">
                            <b-button variant="outline-primary" class="mr-1">
                                <b-icon icon="arrow-up" aria-hidden="true"></b-icon>
                                Helpful <strong v-if="numHelpful > 0">{{numReactionUseful}}</strong>
                            
                            </b-button>
                            <b-button variant="outline-primary" class="mr-1">
                                <b-icon icon="arrow-down" aria-hidden="true"></b-icon>
                                Not Helpful <strong v-if="numNotHelpful > 0">{{numReactionUseful}}</strong>
                            
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
            <template #modal-footer>
                <div>
                    {{slideNumber}} of {{photos.length}}
                </div>
            </template>
        </b-modal>
        <b-container>
            <b-row class="my-3">
                <b-col>
                    <b-container>
                        <b-row>
                            <p class="h3">
                                <strong>Photos for {{place.name}}</strong>
                            </p>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-row>
                                    <div>
                                        <b-img 
                                            rounded 
                                            :src="place.imageUrl" 
                                            alt="Image 1"
                                            height="40px"
                                            width="40px"
                                        >
                                        </b-img>
                                    </div>
                                    <div class="ml-4">
                                        <b-row>
                                            <b-link @click="goToPlace">
                                                {{place.name}}
                                            </b-link>
                                        </b-row>
                                        <b-row>
                                            <div>
                                                <Star
                                                    :rating="place.averageRating"
                                                    :fontScale=1
                                                    :readOnly=true
                                                /> 
                                            </div>
                                            <div>
                                                <span class="ml-1 text-muted">{{place.numberOfRatings}} reviews</span>
                                            </div>
                                        </b-row>
                                    </div>
                                </b-row>
                            </b-col>
                            <b-col class="text-right pr-0">
                                <b-button @click="addPhotos" variant="primary" class="mr-2">
                                    <b-icon icon="camera" aria-hidden="true" class="mr-2"></b-icon>Add photos
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <hr/>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-skeleton-img v-if="place_photos_retrieveing"></b-skeleton-img>
                    <div @click="photoClick(photo.counter)" 
                        v-for="photo in photos"
                        :key="photo.id"
                        style="display: inline"
                    >
                        <b-img-lazy
                            rounded 
                            :src="photo.link" 
                            alt="Image 1"
                            height="150px"
                            width="150px"
                            class="m-2"
                            blank-color="pink"
                        />
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style scoped>
.photos {
    padding-top: 1%;
    margin-right: 20%;
    margin-left: 20%;
}
</style>

<script>
import Star from '../components/place/Star'
export default {
    name: 'Photos',
    components: {
        Star
    },
    data() {
        return {
            modalShow: false,
            slideNumber: 0,
            // TODO source this values from actual reactions of photo
            numHelpful: 0,
            numNotHelpful: 0
        }
    },
    computed: {
        place: {
            get() {
                return this.$store.state.place_current_data
            }
        },
        photos: {
            get() {
                return this.$store.state.place_photos_list
            }
        },
        place_photos_retrieveing: {
            get() {
                return this.$store.state.place_photos_retrieveing
            }
        }

    },
    watch: {

    },
    methods: {
        goToPlace() {
            this.$router.push({
                name: 'Place'
            })
        },
        photoClick(photoNumber) {
            console.log('photo clicked', photoNumber)
            this.modalShow = true
            this.slideNumber = photoNumber
        },
        addPhotos() {
            console.log('addPhotos')
            // TODO
            alert('future feature')
        }
    },
    mounted() {
        // check if place is loaded
        if(this.place) {
            console.log('place is not null')
        } else {
            console.log('place is null')
        }
        var placeId = this.$route.params.id
        this.$store.dispatch('retrievePlace', placeId)

        // retrieve photos
        this.$store.dispatch('retrievePlacePhotos')
    }
}
</script>